/**
 * Created by razial on 14.01.2026
 */

const BareJSON = {
    RESERVED: new Set(["\\", "{", "}", "[", "]", ":", ","]),

    escapeBare: function (s) {
        s = String(s);
        let out = "";
        for (let i = 0; i < s.length; ++i) {
            const ch = s[i];
            if (this.RESERVED.has(ch)) {
                out += `\\${ch}`;
            } else {
                out += ch;
            }
        }
        return out;
    },

    unescapeBare: function (s) {
        let out = "";
        for (let i = 0; i < s.length; ++i) {
            const ch = s[i];
            if (ch !== "\\") {
                out += ch;
                continue;
            }
            if (i + 1 >= s.length) {
                throw new Error("Dangling escape at end of string");
            }
            out += s[++i];
        }
        return out;
    },

    stringify: function (value) {
        if (value === null) {
            return "null";
        }

        const t = typeof value;

        if (t === "boolean" || t === "number" || t === "string") {
            return this.escapeBare(value);
        }

        if (t === "object") {
            if (Array.isArray(value)) {
                return `[${value.map(this.stringify, this).filter((v) => v !== undefined).join(",")}]`;
            }

            const properties = [];
            for (const k of Object.keys(value)) {
                const v = this.stringify(value[k]);
                if (v !== undefined) {
                    properties.push(`${this.escapeBare(k)}:${v}`);
                }
            }
            return `{${properties.join(",")}}`;
        }

        return undefined;
    },

    parse: function (input) {
        const s = String(input);
        let i = 0;

        parseValue = () => {
            if (i >= s.length) {
                throw new Error("Unexpected end of input");
            }

            if (s[i] === "{") {
                return parseObject();
            }
            if (s[i] === "[") {
                return parseArray();
            }

            const tok = parseToken();

            if (tok === "null") {
                return null;
            }
            if (tok === "true") {
                return true;
            }
            if (tok === "false") {
                return false;
            }

            return this.unescapeBare(tok);
        };

        parseToken = () => {
            let out = "";
            while (i < s.length) {
                const ch = s[i];

                if (ch === "\\") {
                    out += ch + s[i + 1];
                    i += 2;
                    continue;
                }

                if (ch === "," || ch === "]" || ch === "}" || ch === ":") {
                    break;
                }

                out += ch;
                ++i;
            }
            return out;
        };

        parseArray = () => {
            ++i;

            const arr = [];

            while (true) {
                if (s[i] === ",") {
                    ++i;
                    continue;
                }

                if (s[i] === "]") {
                    ++i;
                    break;
                }

                arr.push(parseValue());
            }
            return arr;
        };

        parseObject = () => {
            ++i;

            const obj = {};

            while (true) {
                if (s[i] === ",") {
                    ++i;
                    continue;
                }

                if (s[i] === "}") {
                    ++i;
                    break;
                }

                const key = parseToken();

                if (s[i] !== ":") {
                    throw new Error(`Expected ':' at position ${i}`);
                }

                ++i;

                obj[this.unescapeBare(key)] = parseValue();
            }
            return obj;
        };

        const result = parseValue();
        if (i !== s.length) {
            throw new Error(`Trailing characters at position ${i}`);
        }
        return result;
    }
};
